import { render, staticRenderFns } from "./sub-slide-primary.vue?vue&type=template&id=9e8f8d1e&scoped=true"
import script from "./sub-slide-primary.vue?vue&type=script&lang=js"
export * from "./sub-slide-primary.vue?vue&type=script&lang=js"
import style0 from "./sub-slide-primary.vue?vue&type=style&index=0&id=9e8f8d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8f8d1e",
  null
  
)

export default component.exports